<template>
  <v-app>
    <v-app-bar
      app
      elevation="0"
      :height="90"
      color="background"
      class="public-bar"
    >
      <v-row
        no-gutters
        align="center"
      >
        <v-col
          cols="7"
        >
          <router-link
            to="/"
          >
            <v-img
              :src="logo"
              alt="SorareMega logo"
              max-height="50"
              max-width="50"
              class="d-inline-block vertical-align-middle mr-2"
              cover
              :width="106"
            />
            <h1
              class="d-inline-block vertical-align-middle ml-sm-3 text-xs-h4"
            >
              SORAREMEGA
            </h1>
          </router-link>
        </v-col>
        <v-col
          cols="5"
          class="text-right"
        />
      </v-row>
    </v-app-bar>

    <v-main
      :class="{ 'scrollable': isScrollable }"
    >
      <v-container fluid>
        <router-view />
      </v-container>
      <footer-component />
      <cookie-dialog />
    </v-main>
  </v-app>
</template>

<script>
import FooterComponent from '@/layouts/Footer.vue';
import CookieDialog from '@/components/CookieDialog.vue';
import logo from '@/assets/logo.svg';

export default {
  name: 'PublicLayout',
  components: {
    FooterComponent,
    CookieDialog,
  },
  data() {
    return {
      logo
    };
  },
  computed: {
    currentPath() {
      return this.$route.path;
    },
    isScrollable() {
      const scrollablePath = ['/login', '/privacy-policy', '/coming-soon'];

      return scrollablePath.includes(this.currentPath);
    },
  },
};
</script>

<style scoped lang="scss">
.v-main {
  margin-top: 90px;
  padding: 0 !important;
  overflow-y: hidden;
  height: calc(100% - 90px);
}

.scrollable {
  overflow-y: auto !important;
}

.scrollable .v-container {
  min-height: calc(100% - 56px);
  height: auto;
}

.v-application{
  height: 100%;
}

.v-container {
  height: calc(100% - 56px);
  padding: 12px 0;
  position: relative;
}

h1 {
  font-family: "Titillium Web", sans-serif;
}

@media (max-width: 600px) {
  .text-xs-h4 {
    font-size: 1.4rem !important;
    font-weight: 500;
  }
}
</style>
